import React from 'react'

import type { EmbedFeedParams } from '@core/types'

import ThumbnailWrapper from './ThumbnailWrapper'

interface IProps {
  isLarge: boolean
  mode: EmbedFeedParams['mode']
  isSmall?: boolean
}

/**
 * Single placelholder for embed feed.
 */
const Placeholder: React.FunctionComponent<IProps> = ({
  isLarge,
  isSmall,
  mode,
}) => {
  return (
    <ThumbnailWrapper
      isPlaceholder
      isLarge={isLarge}
      mode={mode}
      isSmall={isSmall}
    ></ThumbnailWrapper>
  )
}

export default Placeholder
